import { render, staticRenderFns } from "./PeopleManagerTable.vue?vue&type=template&id=318fe91c&scoped=true"
import script from "./PeopleManagerTable.vue?vue&type=script&lang=js"
export * from "./PeopleManagerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318fe91c",
  null
  
)

export default component.exports